import React, {Component} from "react";
import {Link} from "react-router-dom";
import Analyze from "./analyze";
import axios from "axios";
import {API_URL} from '../env'
import Header from "../header";

class MatchMaking extends Component {
    constructor() {
        super();
        this.state = {
            resumeData: [],
            responseLoading: true,
        };
    }

    componentDidMount(){
        const requirement = this.props.location.state.requirement;
        if(requirement == null || requirement == undefined){
            window.location.replace("/")
        }
        const url = `${API_URL.url}/requirement`
        axios.post(url, {textInput: requirement, upload: 'false'})
            .then(res => {
                this.setState({resumeData: {resumeData: res.data}});
                this.setState({responseLoading: false});
            }).catch((error) => {
            throw error;
        })
    }

    render() {
        const {responseLoading, resumeData} = this.state;
        const data = this.props.location.state;
        return (
            <div>
                <Header/>
                <div className="matchmaking">
                    <div className="frame-container">
                        <iframe className="jd-frame" src={data.jdPath}></iframe>
                    </div>
                    {
                        resumeData ?
                        <div className="requirement">
                            <Analyze data={resumeData} loading={responseLoading}/>
                        </div> : <div>No Data Found</div>
                    }
                </div>
            </div>
        )
    }
}

export default MatchMaking;
